import { EChecklistTaskStatus, Portal, PublisherInfo } from 'common/contracts';
import { FormikErrors, FormikTouched } from 'formik';

import { EApiVersion } from '../DeveloperSettings.types';

interface IPublisherQueryState {
  isLoading: boolean;
  data: PublisherInfo | undefined;
}

export const getErrorMessage = <T extends Record<string, any>>(
  fieldName: keyof T,
  touched: FormikTouched<T>,
  errors: FormikErrors<T>
): string | undefined => {
  if (touched[fieldName]) {
    return errors[fieldName] as string;
  }
  return undefined;
};

export const getIsVersionSelected = (
  selectedVersion: string,
  targetVersion: EApiVersion,
  isFeatureFlagOn: boolean
): boolean | undefined => {
  if (!isFeatureFlagOn) {
    return undefined;
  }
  return selectedVersion === targetVersion;
};

export const createVersionSelectHandler = (
  targetVersion: EApiVersion,
  isFeatureFlagOn: boolean,
  setFieldValue: (field: string, value: string) => void
): (() => void) | undefined => {
  if (!isFeatureFlagOn) {
    return undefined;
  }
  return () => setFieldValue('selectedAwardingVersion', targetVersion);
};

export const determineIsLoading = (
  isPortalContext: boolean,
  portalData: Portal | undefined,
  getPublisher: IPublisherQueryState
): boolean => {
  if (isPortalContext) {
    return !portalData;
  }
  return getPublisher.isLoading || !getPublisher.data;
};

export const getNavigationPath = (domain: string): string => {
  const isAbsoluteUrl = /^https?:\/\//i.test(domain);
  if (isAbsoluteUrl) {
    return domain;
  }
  return `https://${domain}`;
};

export const determineTaskStatusByValue = (value: string | undefined): EChecklistTaskStatus => {
  if (value?.trim()) {
    return EChecklistTaskStatus.DONE;
  }
  return EChecklistTaskStatus.OPEN;
};

export const determineSelectedAwardingVersion = (ratio: number | undefined): string => {
  if (ratio === undefined || ratio === null) {
    return 'V1';
  }
  if (ratio >= 0.5) {
    return 'V2';
  }
  return 'V1';
};

export const computeAwardingV2Ratio = (selectedVersion: string): number => {
  if (selectedVersion === 'V2') {
    return 1;
  }
  return 0;
};

export const determineTaskStatusByHasValue = (hasValue: boolean): EChecklistTaskStatus => {
  if (hasValue) {
    return EChecklistTaskStatus.DONE;
  }
  return EChecklistTaskStatus.OPEN;
};
